module.exports = __webpack_public_path__ + "static/media/fast-icon.6c9e80ee.svg";